/* Triumph DATA PLATE | tl-facets.js (CS area)
   Storefront filtering, sort and "Load more" for the collection and search pages.
   Every [data-tl-facets-root] (main-collection / main-search) holds one GET form
   ([data-tl-facets-form]; the sort select joins it with form=""). Without JS the form submits
   normally (Apply filters / Sort buttons). With JS:
     - a change submits at once (price inputs after a pause) through the Section Rendering API:
       GET <url>&section_id=<id>, then every [data-tl-facets-part] region is swapped with the
       fresh one, the URL is updated with history.replaceState and focus stays on the control;
     - chip / "Clear all" links ([data-tl-facet-link]) are fetched the same way;
     - "Load more" / "Show more" ([data-tl-more]) appends the next page's cards;
     - under 960px the filter plate is a drawer (focus trap, Esc, scroll lock).
   Emits document event 'tl:facets:updated' {detail:{root, url}} after each update (tl-compare.js
   re-syncs its buttons on it). Re-initialises on shopify:section:load. */
(function () {
  'use strict';

  var TL = window.TL || (window.TL = {});
  var DRAWER_MQ = '(max-width: 959px)';
  var instances = [];

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    if (typeof TL.debounce === 'function') return TL.debounce(fn, ms);
    var t;
    return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); };
  }
  function emit(name, detail) {
    var ev;
    try { ev = new CustomEvent(name, { bubbles: true, detail: detail }); } catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent(name, true, false, detail); }
    document.dispatchEvent(ev);
  }
  function withSection(url, sectionId) {
    var u = new URL(url, window.location.href);
    u.searchParams.delete('section_id');
    u.searchParams.set('section_id', sectionId);
    return u.pathname + u.search;
  }
  function cleanUrl(url) {
    var u = new URL(url, window.location.href);
    u.searchParams.delete('section_id');
    return u.pathname + u.search + u.hash;
  }

  function Facets(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.form = $('[data-tl-facets-form]', root);
    this.drawer = $('[data-tl-facets-drawer]', root);
    this.openBtn = $('[data-tl-facets-open]', root);
    this.backdrop = $('.tl-qdrw__bg', root);
    this.mq = window.matchMedia ? window.matchMedia(DRAWER_MQ) : null;
    this.expanded = {};
    this.controller = null;
    this.isOpen = false;
    this.bind();
  }

  Facets.prototype.bind = function () {
    var self = this;
    var priceSubmit = debounce(function () { self.submit(); }, 700);

    this.onChange = function (e) {
      var t = e.target;
      if (!t || !t.form || t.form !== self.form) return;
      if (t.hasAttribute('data-tl-facet-price')) { priceSubmit(); return; }
      self.submit();
    };
    this.onInput = function (e) {
      var t = e.target;
      if (t && t.hasAttribute && t.hasAttribute('data-tl-facet-price') && t.form === self.form) priceSubmit();
    };
    this.onSubmit = function (e) {
      if (e.target !== self.form) return;
      e.preventDefault();
      self.submit();
    };
    this.onClick = function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('a[data-tl-facet-link]');
      if (link && self.root.contains(link)) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
        e.preventDefault();
        self.render(link.getAttribute('href'));
        return;
      }
      var more = t.closest('[data-tl-facet-more]');
      if (more && self.root.contains(more)) {
        var key = more.getAttribute('data-tl-facet-more');
        var open = more.getAttribute('aria-expanded') !== 'true';
        self.expanded[key] = open;
        self.applyExpanded();
        return;
      }
      var loadMore = t.closest('[data-tl-more]');
      if (loadMore && self.root.contains(loadMore)) {
        e.preventDefault();
        self.loadMore(loadMore);
        return;
      }
      if (t.closest('[data-tl-facets-open]')) { self.open(); return; }
      if (t.closest('[data-tl-facets-close]')) { self.close(true); }
    };
    this.onKey = function (e) {
      if (self.isOpen && (e.key === 'Escape' || e.key === 'Esc')) { e.preventDefault(); self.close(true); }
    };
    this.onMq = function () { if (self.isOpen && !self.mq.matches) self.close(false); };

    this.root.addEventListener('change', this.onChange);
    this.root.addEventListener('input', this.onInput);
    this.root.addEventListener('submit', this.onSubmit);
    this.root.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKey);
    if (this.mq) {
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);
    }
  };

  Facets.prototype.destroy = function () {
    this.close(false);
    if (this.controller) { try { this.controller.abort(); } catch (e) { /* ignore */ } }
    this.root.removeEventListener('change', this.onChange);
    this.root.removeEventListener('input', this.onInput);
    this.root.removeEventListener('submit', this.onSubmit);
    this.root.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKey);
    if (this.mq) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
      else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
    }
    delete this.root.dataset.tlInit;
  };

  /* The form's current state as a URL (empty values dropped, page reset). */
  Facets.prototype.formUrl = function () {
    var form = this.form;
    var action = new URL(form.getAttribute('action') || window.location.pathname, window.location.href);
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, key) {
      if (typeof value === 'string' && value.trim() === '') return;
      params.append(key, value);
    });
    var qs = params.toString();
    return action.pathname + (qs ? '?' + qs : '');
  };

  Facets.prototype.submit = function () {
    if (!this.form) return;
    this.render(this.formUrl());
  };

  Facets.prototype.fetchSection = function (url) {
    var self = this;
    if (this.controller) { try { this.controller.abort(); } catch (e) { /* ignore */ } }
    this.controller = window.AbortController ? new AbortController() : null;
    return fetch(withSection(url, this.sectionId), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: this.controller ? this.controller.signal : undefined
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-tl-facets-root]');
      if (!fresh) throw new Error('section missing');
      self.controller = null;
      return fresh;
    });
  };

  Facets.prototype.render = function (url) {
    var self = this;
    var root = this.root;
    var active = document.activeElement;
    var activeId = active && root.contains(active) ? active.id : '';
    root.classList.add('is-loading');
    var results = $('[data-tl-results]', root);
    if (results) results.setAttribute('aria-busy', 'true');

    this.fetchSection(url).then(function (fresh) {
      self.swap(fresh);
      root.classList.remove('is-loading');
      var r = $('[data-tl-results]', root);
      if (r) r.removeAttribute('aria-busy');
      try { window.history.replaceState(window.history.state, '', cleanUrl(url)); } catch (e) { /* ignore */ }
      if (activeId) {
        var again = document.getElementById(activeId);
        if (again && again !== document.activeElement) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
      } else if (active && !document.body.contains(active)) {
        var target = self.isOpen ? self.drawer : $('[data-tl-count]', root);
        if (target) {
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
        }
      }
      emit('tl:facets:updated', { root: root, url: cleanUrl(url) });
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      window.location.href = cleanUrl(url);
    });
  };

  /* Swap every [data-tl-facets-part] region with its fresh copy (the element itself stays, so live
     regions announce and listeners on the root keep working). */
  Facets.prototype.swap = function (fresh) {
    $$('[data-tl-facets-part]', this.root).forEach(function (el) {
      var name = el.getAttribute('data-tl-facets-part');
      var src = fresh.querySelector('[data-tl-facets-part="' + name + '"]');
      if (!src) return;
      el.innerHTML = src.innerHTML;
      if (src.hasAttribute('hidden')) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
    });
    // the sort select is not swapped: keep its value in step with the response
    var sort = $('[data-tl-facet-sort]', this.root);
    var freshSort = fresh.querySelector('[data-tl-facet-sort]');
    if (sort && freshSort && sort.value !== freshSort.value) sort.value = freshSort.value;
    this.applyExpanded();
  };

  Facets.prototype.applyExpanded = function () {
    var self = this;
    $$('[data-tl-facet-more]', this.root).forEach(function (btn) {
      var key = btn.getAttribute('data-tl-facet-more');
      var open = !!self.expanded[key];
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      if (list) list.classList.toggle('is-all', open);
    });
  };

  /* "Load more": append the next page's cards, then refresh the count, button and pager. */
  Facets.prototype.loadMore = function (btn) {
    var self = this;
    var next = btn.getAttribute('data-next-url');
    if (!next || btn.getAttribute('aria-busy') === 'true') return;
    var grid = $('[data-tl-grid]', this.root);
    if (!grid) { window.location.href = next; return; }
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-busy');
    btn.textContent = (TL.strings && TL.strings.loading) || 'Loading…';
    var before = grid.children.length;

    this.fetchSection(next).then(function (fresh) {
      var freshGrid = fresh.querySelector('[data-tl-grid]');
      var items = freshGrid ? Array.prototype.slice.call(freshGrid.children) : [];
      items.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });

      var count = $('[data-tl-count]', self.root);
      var freshCount = fresh.querySelector('[data-tl-count]');
      if (count && freshCount) {
        var from = parseInt(count.getAttribute('data-from'), 10) || 1;
        var to = parseInt(freshCount.getAttribute('data-to'), 10) || 0;
        var total = parseInt(freshCount.getAttribute('data-total'), 10) || 0;
        count.setAttribute('data-to', to);
        count.setAttribute('data-total', total);
        count.textContent = from === 1 ? 'Showing ' + to + ' of ' + total : 'Showing ' + from + '–' + to + ' of ' + total;
      }
      var wrap = btn.closest('[data-tl-more-wrap]');
      var freshBtn = fresh.querySelector('[data-tl-more]');
      if (freshBtn) {
        btn.setAttribute('data-next-url', freshBtn.getAttribute('data-next-url'));
        btn.textContent = label;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-busy');
      } else if (wrap) {
        wrap.setAttribute('hidden', '');
      }
      var pager = $('[data-tl-pager]', self.root);
      var freshPager = fresh.querySelector('[data-tl-pager]');
      if (pager && freshPager) pager.innerHTML = freshPager.innerHTML;

      var first = grid.children[before];
      var link = first && first.querySelector('a[href]');
      if (link) { try { link.focus({ preventScroll: false }); } catch (e) { link.focus(); } }
      if (typeof TL.announce === 'function' && count) TL.announce(count.textContent);
      emit('tl:facets:updated', { root: self.root, url: cleanUrl(next), append: true });
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      window.location.href = cleanUrl(next);
    });
  };

  /* ── drawer (phones) ─────────────────────────────────────────────────── */
  Facets.prototype.open = function () {
    if (!this.drawer || this.isOpen) return;
    if (this.mq && !this.mq.matches) return;
    this.isOpen = true;
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('role', 'dialog');
    this.drawer.setAttribute('aria-modal', 'true');
    if (this.drawer.getAttribute('data-labelledby')) this.drawer.setAttribute('aria-labelledby', this.drawer.getAttribute('data-labelledby'));
    if (!this.drawer.hasAttribute('tabindex')) this.drawer.setAttribute('tabindex', '-1');
    if (this.backdrop) this.backdrop.removeAttribute('hidden');
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    if (typeof TL.lockScroll === 'function') TL.lockScroll(true);
    var closeBtn = $('.tl-qx', this.drawer);
    if (typeof TL.trapFocus === 'function') TL.trapFocus(this.drawer, closeBtn || undefined);
    else if (closeBtn) closeBtn.focus();
  };

  Facets.prototype.close = function (restoreFocus) {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.drawer.classList.remove('is-open');
    this.drawer.removeAttribute('role');
    this.drawer.removeAttribute('aria-modal');
    this.drawer.removeAttribute('aria-labelledby');
    if (this.backdrop) this.backdrop.setAttribute('hidden', '');
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'false');
    if (typeof TL.lockScroll === 'function') TL.lockScroll(false);
    if (typeof TL.removeTrapFocus === 'function') TL.removeTrapFocus(restoreFocus ? this.openBtn : undefined);
    else if (restoreFocus && this.openBtn) this.openBtn.focus();
  };

  /* ── lifecycle ───────────────────────────────────────────────────────── */
  function init(scope) {
    $$('[data-tl-facets-root]', scope || document).forEach(function (root) {
      if (root.dataset.tlInit) return;
      root.dataset.tlInit = '1';
      instances.push(new Facets(root));
    });
  }
  function destroy(scope) {
    instances = instances.filter(function (inst) {
      if (scope.contains(inst.root)) { inst.destroy(); return false; }
      return true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) instances.forEach(function (inst) { inst.close(false); inst.root.classList.remove('is-loading'); });
  });

  TL.facets = { init: init };
})();
